<div class="mp-page">
  <header class="mp-header">
    <button type="button" class="mp-back" (click)="cancel()" aria-label="Back">
      <i class="fas fa-arrow-left" aria-hidden="true"></i>
    </button>
    <div class="mp-heading">
      <h1 class="mp-title">Travellers &amp; class</h1>
      <p class="mp-sub">Up to 9 travellers per booking</p>
    </div>
  </header>

  <div class="mp-body">
    <h2 class="mp-label">Travellers</h2>
    <div class="mp-card">
      <div class="mp-counter">
        <div class="mp-counter__text">
          <span class="mp-counter__icon" aria-hidden="true"><i class="fas fa-user"></i></span>
          <span>
            <span class="mp-counter__name">Adults</span>
            <span class="mp-counter__age">12 years or older</span>
          </span>
        </div>
        <div class="mp-stepper">
          <button type="button" class="mp-stepper__btn" [disabled]="!canStep('adults', -1)" (click)="step('adults', -1)" aria-label="Fewer adults">
            <i class="fas fa-minus" aria-hidden="true"></i>
          </button>
          <span class="mp-stepper__value" aria-live="polite">{{ adults }}</span>
          <button type="button" class="mp-stepper__btn" [disabled]="!canStep('adults', 1)" (click)="step('adults', 1)" aria-label="More adults">
            <i class="fas fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div class="mp-counter">
        <div class="mp-counter__text">
          <span class="mp-counter__icon" aria-hidden="true"><i class="fas fa-child"></i></span>
          <span>
            <span class="mp-counter__name">Children</span>
            <span class="mp-counter__age">2 to 11 years</span>
          </span>
        </div>
        <div class="mp-stepper">
          <button type="button" class="mp-stepper__btn" [disabled]="!canStep('children', -1)" (click)="step('children', -1)" aria-label="Fewer children">
            <i class="fas fa-minus" aria-hidden="true"></i>
          </button>
          <span class="mp-stepper__value" aria-live="polite">{{ children }}</span>
          <button type="button" class="mp-stepper__btn" [disabled]="!canStep('children', 1)" (click)="step('children', 1)" aria-label="More children">
            <i class="fas fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div class="mp-counter">
        <div class="mp-counter__text">
          <span class="mp-counter__icon" aria-hidden="true"><i class="fas fa-baby"></i></span>
          <span>
            <span class="mp-counter__name">Infants</span>
            <span class="mp-counter__age">Under 2 years</span>
          </span>
        </div>
        <div class="mp-stepper">
          <button type="button" class="mp-stepper__btn" [disabled]="!canStep('infants', -1)" (click)="step('infants', -1)" aria-label="Fewer infants">
            <i class="fas fa-minus" aria-hidden="true"></i>
          </button>
          <span class="mp-stepper__value" aria-live="polite">{{ infants }}</span>
          <button type="button" class="mp-stepper__btn" [disabled]="!canStep('infants', 1)" (click)="step('infants', 1)" aria-label="More infants">
            <i class="fas fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
    <p class="mp-hint">
      <i class="fas fa-info-circle" aria-hidden="true"></i>
      Infants travel on an adult's lap, one per adult.
    </p>

    <h2 class="mp-label">Cabin class</h2>
    <div class="mp-classes" role="radiogroup" aria-label="Cabin class">
      @for (cabin of cabinOptions; track cabin.value) {
        <label class="mp-class" [class.mp-class--active]="selectedClass === cabin.value">
          <input type="radio" name="cabinClass" [value]="cabin.value" [checked]="selectedClass === cabin.value" (change)="selectedClass = cabin.value">
          <span class="mp-class__radio" aria-hidden="true"></span>
          <span class="mp-class__name">{{ cabin.label }}</span>
        </label>
      }
    </div>
  </div>

  <footer class="mp-footer">
    <div class="mp-footer__summary">
      <span class="mp-footer__label">Your selection</span>
      <span class="mp-footer__value">{{ travellersInput }}</span>
    </div>
    <button type="button" class="mp-btn" (click)="donePassengers()">Done</button>
  </footer>
</div>
